
import Vue from 'vue';
import _cookie from 'cookie-monster'
import _axios from './axios'
import _validator from 'validator'
import devConfig from '@/devConfig'

let Plugin = {}
Plugin.install = function (Vue, options) {
	Vue.axios = _axios;
	window.axios = _axios;
	Vue.cookie = _cookie;
	window.cookie = _cookie;
	Vue.validator = _validator;
	window.validator = _validator;
	Object.defineProperties(Vue.prototype, {
		axios: {
			get() {
				return _axios;
			}
		},
		$axios: {
			get() {
				return _axios;
			}
		},
		cookie: {
			get() {
				return _cookie;
			}
		},
		$cookie: {
			get() {
				return _cookie;
			}
		},
		validator: {
			get() {
				return _validator;
			}
		},
		$validator: {
			get() {
				return _validator;
			}
		},
		G_DEVICE_CFG: {
			get() {
				return devConfig.getData();
			}
		},
		$G_DEVICE_CFG: {
			get() {
				return devConfig.getData();
			}
		},
		$isINTL: {
			get() {
				return process.env.VUE_APP_FH_ARER === 'INTL';
			}
		},
		$isAis: {
			get() {
				return process.env.VUE_APP_FH_ARER === 'AIS';
			}
		},
		$isTRUE: {
			get() {
				return process.env.VUE_APP_FH_ARER === 'TRUE';
			}
		},
		$isBRAZIL: { // 巴西版本
			get() {
				const arer = devConfig.getData().area
				return arer === 'BRISANET' || arer === 'WDC' || arer === 'ALGAR';
			}
		},
		$isCLARO: { // 哥伦比亚
			get() {
				return devConfig.getData().area === 'CLARO';
			}
		},
	});
};

Vue.use(Plugin);

export default Plugin;